import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

/**
 *
 * @param Button - Button component to be used
 * @param items - Array of button props
 *
 * renders a list of buttons in one line dividing the parents width equally
 */ const HorizontalButtonGroup = (_param)=>{
    var { Button , items , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "Button",
        "items",
        "className"
    ]);
     return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('horizontal-button-group', className)
    }), items.map((item)=>{
         return React.createElement(Button, swcHelpers.extends({}, item, {
            key: item.itemID,
            className: classnames(item === null || item === void 0 ? void 0 : item.className, 'horizontal-button-group__item')
        }));
    }));
};
var HorizontalButtonGroup$1 = HorizontalButtonGroup;

export { HorizontalButtonGroup$1 as default };
//# sourceMappingURL=HorizontalButtonGroup.js.map
